define('gameday-index-configurator/GamedayIndexConfigurator',['require','exports','module','./src/model/valueObjects/SiteConfig','./src/model/valueObjects/GDConfig','./src/model/valueObjects/SkinConfig','./src/model/valueObjects/BuildConfig','extant/extant'],function(require, exports, module) {
	// require imports
	var SiteConfig = require("./src/model/valueObjects/SiteConfig"),
		GDConfig = require("./src/model/valueObjects/GDConfig"),
		SkinConfig = require("./src/model/valueObjects/SkinConfig"),
		BuildConfig = require("./src/model/valueObjects/BuildConfig"),
		exists = require("extant/extant");

	//  instance vars here, har har.
	var instance = null;

	function GamedayConfigurator() {
		if (exists(instance)) {
			throw new Error("What are you doing?! Cannot instantiate more than one configurator!");
		}

		// oh yeah! bustin' walls like the kool-aid man on pcp. let's do this...
	}

	GamedayConfigurator.prototype = {
		siteConfig: null,
		gdConfig: null,
		skinConfig: null,
		buildManifest: null,

		/**
		 * Public Function init
		 * @param site {Object} json obj of information like domain, tracking and advertising suites etc
		 * @param gameday {Object} json obj detailing game information, teams leagues etc
		 * @param skin {Object} json obj setting what features are available etc
		 * @param build {Object} json obj detailing what components are on the page build and what their target divs are
		 */
		init: function(site, gameday, skin, build) {
			this.siteConfig = new SiteConfig(site);
			this.gdConfig = new GDConfig(gameday);
			this.skinConfig = new SkinConfig(skin);
			this.buildManifest = new BuildConfig(build);
		},


		getInitListener: function() {
			return this.siteConfig.getInitListener();
		},

		/**
		 * Public Function getBuildManifest
		 * @returns {Object} buildConfig
		 */
		getBuildManifest: function() {
			return this.buildManifest.getManifest();
		},

		/**
		 * Public Function getLeague
		 * @param {String} "home" or "away". undefined will return "home" league as default
		 * @returns {String}
		 */
		getLeauge: function(homeAway) {
			return (homeAway === "away") ? this.gdConfig.away.legaue : this.gdConfig.home.league;
		},

		/**
		 * Public Function getSiteConfig
		 * returns {Object} siteConfig
		 */
		getSiteConfig: function() {
			return this.siteConfig;
		},

		/**
		 * Public Function getTrackingConfig
		 * @return {Object} Tracking config parameters and inital values
		 */
		getLoginStatus: function() {
			return this.siteConfig.getLoginStatus();
		},
		
		/**
		 * Public Function getSecureDomain
		 * @return {Object} Tracking config parameters and inital values
		 */
		getSecureDomain: function() {
			return this.siteConfig.getSecureDomain();
		},


		/**
		 * Public Function getTrackingConfig
		 * @return {Object} Tracking config parameters and inital values
		 */
		setLoginStatus: function(state) {
			this.siteConfig.setLoginStatus(state);
		},
		

		/**
		 * Public Function getAdRefreshRate
		 * returns {number} in seconds
		 */
		getAdRefreshRate: function() {
			return this.siteConfig.getAdRefreshRate();
		},
		
				
		/**
		 * Public Function getMediaService
		 * @return {Object} Media Service Url
		 */
		getMediaService: function(state) {
			return this.siteConfig.getMediaService();
		},
		
		
		/**
		 * Public Function getSiteProperty
		 * @return {Object} return Site Property for video player
		 */
		getSiteProperty: function(state) {
			return this.siteConfig.getSiteProperty();
		},
		
		

		/**
		 * Public Function getAdDefs
		 * @returns {Object} adUnits from siteConfig (or empty object)
		 */
		getAdDefs: function() {
			return this.siteConfig.getAdPlacements();
		},

		/**
		 * Public Function getTrackingConfig
		 * @return {Object} Tracking config parameters and inital values
		 */
		getTrackingConfig: function() {
			return this.siteConfig.getTrackingConfig();
		},

		getGDConfig : function(){
			return this.gdConfig;
		}

	};

	/**
	 * Public Function getInstance
	 * returns single value instance of GameConfigurator
	 * @returns {GameConfigurator}
	 */
	getInstance = function() {
		// summary:
		//      Gets an instance of the singleton. It is better to use
		if (!exists(instance)) {
			instance = new GamedayConfigurator();
		}

		return instance;
	};

	return getInstance();
});
